var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-empty-state',{attrs:{"svg-path":_vm.emptyStatePath,"svg-height":null,"title":_vm.emptyStateTitle},scopedSlots:_vm._u([(_vm.showDescription)?{key:"description",fn:function(){return [_vm._v("\n    "+_vm._s(_vm.__('Track groups of issues that share a theme, across projects and milestones'))+"\n  ")]},proxy:true}:null],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }